import { useContext } from 'react';
import { FluxoDeCaixaContext } from '../context/FluxoDeCaixaContext';
import { FluxoDeCaixaContextData } from '../types/context';

export const useFluxoDeCaixa = (): FluxoDeCaixaContextData =>
  useContext(FluxoDeCaixaContext);
